import { Row } from "react-bootstrap";

const AccountDetails = ({ account }) => {
    return (
        <div className="item-details">
            { account && 
                <article>
                    <Row><h2>Account: { account.currency }</h2></Row>
                    <Row><h3>ID: { account.id.toUpperCase() }</h3></Row>
                    <Row><h3>Balance: { account.balance }</h3></Row>
                </article>
            }
        </div>
       
    );
}
 
export default AccountDetails;